module.exports = __webpack_public_path__ + "static/media/junipermail.f7105d5a.jpg";